export default "__VITE_ASSET__7qGbI0nr__"